import React, { memo } from "react";
import {
  Container,
  Carousel,
  Row,
  Col,
  Badge,
  Button
} from "react-bootstrap";
import { Link } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";

// Resim importları
import hukuk from "../assets/icons/hukuk.png";
import law from "../assets/icons/law.png";

const SLIDE_IMAGES = [hukuk, law];

const Index = () => {
  return (
    <div className="page-wrapper">
      <Container
        fluid
        className="d-flex align-items-center position-relative"
        style={{
          // 1. ZENGİN GRADYAN: Düz renk yerine derinlikli bir geçiş
          background: "linear-gradient(135deg, #000b18 0%, #001f3f 50%, #003366 100%)",
          minHeight: "100vh",
          color: "#fff",
          padding: "80px 0",
          overflow: "hidden",
        }}
      >
        {/* Arka Plan Dekoru (Opsiyonel: Hafif bir parlama efekti katar) */}
        <div style={{
          position: "absolute",
          top: "-10%",
          right: "-5%",
          width: "min(500px, 80vw)", // Responsive width
          height: "min(500px, 80vw)", // Responsive height
          background: "radial-gradient(circle, rgba(100,181,246,0.15) 0%, rgba(0,0,0,0) 70%)",
          borderRadius: "50%",
          zIndex: 0,
          pointerEvents: "none"
        }} />

        <Container style={{ zIndex: 1 }}>
          <Row className="align-items-center justify-content-between gy-5">

            {/* --- SOL TARA (Metin & İçerik) --- */}
            <Col lg={6} md={12} className="order-1 order-lg-1">
              <div className="pe-lg-5 d-flex flex-column">
                {/* Yeni Uygulama Duyurusu */}
                <div className="mb-4 order-2 order-lg-1">
                  <Link
                    to="/SatinAl"
                    style={{ textDecoration: 'none' }}
                  >
                    <div
                      className="d-inline-flex align-items-center gap-3 px-5 py-4 rounded-4 shadow-lg"
                      style={{
                        background: "rgba(255,255,255,0.06)",
                        backdropFilter: "blur(16px)",
                        border: "1px solid rgba(100,181,246,0.3)",
                        transition: "all 0.25s ease",
                      }}
                    >
                      {/* Canlı nokta */}
                      <span style={{ position: 'relative', display: 'inline-flex', alignItems: 'center' }}>
                        <span style={{
                          width: 10, height: 10, borderRadius: '50%',
                          background: '#38bdf8',
                          boxShadow: '0 0 0 0 rgba(56,189,248,0.6)',
                          animation: 'pulse-dot 1.8s infinite',
                          display: 'inline-block'
                        }} />
                      </span>
                      <div style={{ color: '#f1f5f9', fontWeight: 700, fontSize: '1.1rem' }}>
                        <span style={{ color: '#38bdf8' }}>Mirasım</span> — App Store ve Google Play'de Yayında
                      </div>
                      <div
                        style={{
                          fontSize: '0.85rem', fontWeight: 700,
                          color: '#38bdf8',
                          border: '1px solid rgba(56,189,248,0.4)',
                          borderRadius: 6,
                          padding: '5px 14px',
                          whiteSpace: 'nowrap',
                          letterSpacing: '0.04em'
                        }}
                      >
                        İncele →
                      </div>
                    </div>
                  </Link>
                  <style>{`
                    @keyframes pulse-dot {
                      0%   { box-shadow: 0 0 0 0 rgba(56,189,248,0.6); }
                      70%  { box-shadow: 0 0 0 8px rgba(56,189,248,0); }
                      100% { box-shadow: 0 0 0 0 rgba(56,189,248,0); }
                    }
                  `}</style>
                </div>

                {/* Büyük Başlık */}
                <h1 className="order-3 order-lg-2" style={{
                  fontSize: "clamp(2.5rem, 5vw, 4rem)", // Responsive Font
                  fontWeight: "800",
                  lineHeight: "1.1",
                  background: "linear-gradient(90deg, #ffffff, #e2e8f0)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                  marginBottom: "20px"
                }}>
                  Miras Hukukunda <br /> Kesin ve Hızlı Çözüm
                </h1>

                <p className="lead mb-3 order-4 order-lg-3" style={{ color: "#e2e8f0", fontWeight: "300" }}>
                  Mirasım, karmaşık miras paylaşımlarını saniyeler içinde hesaplayan, hatasız ve yasalara tam uyumlu sonuçlar sunan profesyonel hukuk asistanınızdır.
                </p>

                <div className="mb-4 p-3 rounded-4 order-5 order-lg-4" style={{ background: "rgba(56, 189, 248, 0.1)", border: "1px solid rgba(56, 189, 248, 0.2)", maxWidth: "90%" }}>
                  <span style={{ color: "#f8fafc", fontSize: "0.95rem", lineHeight: "1.5", display: "block" }}>
                    <strong>Mirasım'ı Keşfedin:</strong> Platformumuza kayıt olarak <strong>Mirasım</strong> uygulamasını 1 günlük demo lisansıyla kurumsal iş akışlarınızda tam kapsamlı olarak test edebilirsiniz.
                  </span>
                </div>

                {/* Buton Grubu */}
                <div className="d-flex flex-wrap gap-3 mb-5 order-1 order-lg-5">
                  <Link to="/Uyeol">
                    <Button size="lg" className="rounded-pill px-4 fw-bold shadow-lg text-dark" style={{ background: "linear-gradient(90deg, #38bdf8, #818cf8)", border: "none" }}>
                      Ücretsiz Kayıt Ol & Demoyu Keşfet
                    </Button>
                  </Link>
                  <Link to="/İletisim">
                    <Button variant="outline-light" size="lg" className="rounded-pill px-4 fw-bold">
                      Bize Ulaşın
                    </Button>
                  </Link>
                </div>

                {/* --- DOLULUK KATAN BÖLÜM: Özellik İkonları --- */}
                {/* Sayfanın altının boş kalmasını engeller */}
                <Row className="g-3 pt-3 border-top border-secondary border-opacity-25 order-6 order-lg-6">
                  {[
                    { title: "Hatasız Hesaplama", desc: "Karmaşık miras paylarında mutlak doğruluk." },
                    { title: "Yasal Uyum", desc: "Güncel mevzuata tam entegre sistem." },
                    { title: "Vasiyet Asistanı", desc: "Saniyeler içinde profesyonel vasiyetname oluşturma." }
                  ].map((item, idx) => (
                    <Col sm={4} key={idx}>
                      <h6 className="fw-bold text-info mb-1">{item.title}</h6>
                      <p className="small text-white-50 mb-0">{item.desc}</p>
                    </Col>
                  ))}
                </Row>
              </div>
            </Col>

            {/* --- SAĞ TARA (Carousel / Görsel) --- */}
            <Col lg={6} md={12} className="order-2 order-lg-2">
              <div className="position-relative">
                {/* Resmin arkasına "Glow" efekti */}
                <div style={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  width: "90%",
                  height: "90%",
                  background: "rgba(56, 189, 248, 0.3)",
                  filter: "blur(60px)",
                  borderRadius: "50%",
                  zIndex: -1
                }}></div>

                <Carousel
                  fade
                  interval={3000}
                  controls={false}
                  indicators={false}
                  pause={false}
                >
                  {SLIDE_IMAGES.map((src, i) => (
                    <Carousel.Item key={i}>
                      <img
                        className="d-block w-100 rounded-5"
                        src={src}
                        alt={`Slide ${i}`}
                        loading={i === 0 ? "eager" : "lazy"}
                        style={{
                          height: "500px", // Sabit yükseklik
                          objectFit: "cover",
                          boxShadow: "0 20px 50px rgba(0,0,0,0.5)", // Daha güçlü gölge
                          border: "1px solid rgba(255,255,255,0.1)"
                        }}
                      />
                    </Carousel.Item>
                  ))}
                </Carousel>
              </div>
            </Col>

          </Row>
        </Container>
      </Container>
    </div>
  );
};

export default memo(Index);
